import React from "react";
import { createRoot } from "react-dom/client";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

function mountDialog(renderer) {
  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = createRoot(container);

  const cleanup = () => {
    try {
      root.unmount();
    } finally {
      if (container.parentNode) container.parentNode.removeChild(container);
    }
  };

  renderer(root, cleanup);
}

export function openAppConfirm({
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "error",
} = {}) {
  return new Promise((resolve) => {
    mountDialog((root, cleanup) => {
      const closeWith = (value) => {
        cleanup();
        resolve(value);
      };

      root.render(
        <Dialog
          open
          onClose={() => closeWith(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              backdropFilter: "blur(6px)",
            },
          }}
        >
          <DialogTitle sx={{ pb: 1 }}>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: "text.primary" }}>{message}</DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="outlined" color="inherit" onClick={() => closeWith(false)}>
              {cancelText}
            </Button>
            <Button variant="contained" color={confirmColor} onClick={() => closeWith(true)}>
              {confirmText}
            </Button>
          </DialogActions>
        </Dialog>
      );
    });
  });
}

export function openAppAlert({
  title = "Notice",
  message = "",
  okText = "OK",
  color = "primary",
} = {}) {
  return new Promise((resolve) => {
    mountDialog((root, cleanup) => {
      const close = () => {
        cleanup();
        resolve(true);
      };

      root.render(
        <Dialog
          open
          onClose={close}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              backdropFilter: "blur(6px)",
            },
          }}
        >
          <DialogTitle sx={{ pb: 1 }}>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: "text.primary" }}>{message}</DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="contained" color={color} onClick={close}>
              {okText}
            </Button>
          </DialogActions>
        </Dialog>
      );
    });
  });
}
